import { userRequest } from "../requestMethods";
import {
  getAppointmentStart,
  getAppointmentSuccess,
  getAppointmentFailure,
} from "../redux/appointmentRedux";

import {
  getReportStart,
  getReportSuccess,
  getReportFailure,
} from "../redux/reportRedux";


import { toast } from "react-toastify";

export const getLabAppointments = async (dispatch, labId) => {
  dispatch(getAppointmentStart());
  try {
    const res = await userRequest.get(`labApi/labAppointmentsRoutes/getLabAppointments/${labId}`);

    if (res.status === 200) {
      console.log(res, "res.data for categories");
      dispatch(getAppointmentSuccess(res.data.data));
    }
  } catch (err) {
    dispatch(getAppointmentFailure());
  }
};


export const getSelectedAppointmentData = async (appointId) => {
  console.log(appointId, 'appointId');
  // dispatch(getSubscriptionStart());
  try {
    const res = await userRequest.get(`labApi/labAppointmentsRoutes/getLabAppointmentData/${appointId}`);
    console.log(res.data.data, "res.data");
    if (res.status === 200) {
      return res.data.data;
    }
  } catch (err) {
    toast.error(err?.response?.data);
    console.log(err, "err at sel subs");
  }
};

export const cancelLabAppointments = async (appointId) => {
  try {
    console.log(appointId, "labid in rating list");
    const res = await userRequest.post(
      `labApi/labAppointmentsRoutes/cancelLabAppointment/${appointId}`
    );
    console.log(res.data, "fetch lab cancel appintments data");
    toast.success(`${res.data.message}`)

    return res.data;
  } catch (err) {
    console.log(err, "err at fetch appointments");
  }
};

export const completeLabAppointments = async (appointId) => {
  try {
    console.log(appointId, "labid in rating list");
    const res = await userRequest.post(
      `labApi/labAppointmentsRoutes/completeLabAppointment/${appointId}`
    );
    toast.success(`${res.data.message}`)

    console.log(res.data, "fetch user appintments");
    return res.data;
  } catch (err) {
    console.log(err, "err at fetch appointments");
  }
};

export const uploadReports = async (uploadFile, appointId, reportName, userId, testId, labId) => {
  try {
    console.log(uploadFile, 'formData')
    const formData = new FormData();

    // TEXT FIELDS
    formData.append("appointmentId", appointId);
    formData.append("reportName", reportName);
    formData.append("userId", userId); 
    formData.append("labId", labId); 
    formData.append("testId", testId);

    uploadFile.forEach((item) => {
      formData.append("reports", item.file); // 👈 ONLY File
    });

    const res = await userRequest.post(
      `labApi/labReportsRoutes/uploadReports/${appointId}`, formData
    );
    // console.log(res, 'res')
    if(res.status === 200){
      return res.data;
    }
  }
  catch (err) {
    console.log(err, "err at fetch appointments");
  }
}

export const getAppointmentReports = async (dispatch, appointId) => {
  dispatch(getReportStart());
  try {
    const res = await userRequest.get(`labApi/labReportsRoutes/fetchReports/${appointId}`);

    if (res.status === 200) {
      console.log(res, "res.data for categories");
      dispatch(getReportSuccess(res.data.data));
    }
  } catch (err) {
    dispatch(getReportFailure());
  }
};

export const deleteAppointmentReport = async (reportId) => {
  try {
    const res = await userRequest.delete(`labApi/labReportsRoutes/deleteReports/${reportId}`);
    console.log(res, 'res')
    if (res.status === 200) {
      toast.success(`${res.data.message}`)
      console.log(res.data, "res.data for categories");
    }
  } catch (err) {
    console.log('delete')
  }
};